import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import {
  CheckboxGroup,
  RadioButtonGroup,
  Slider,
  MultiselectDropdown
} from '../'
import { searchUtils } from '../../utils'
import keywords from '../../keywords'
import './FilteredSearchFilters.sass'


class FilteredSearchFilters extends Component {
  constructor() {
    super()
    this._renderFilterByType = this.renderFilterByType.bind(this)
    this._renderFilterHeader = this.renderFilterHeader.bind(this)
  }

  renderFilterHeader(filter) {
    const { setActiveFilterIds, activeFilterIds } = this.props
    const updatedActiveFilterIds = searchUtils.excludeIdsForFilter(activeFilterIds, filter.filter_terms, filter.filter_type)

    return (
      <div className="header">
        <h5>{filter.name}</h5>
        <button type="button" onClick={() => setActiveFilterIds(updatedActiveFilterIds)}>
          RESET
        </button>
      </div>
    )
  }

  renderFilterByType(filter) {
    const { setActiveFilterIds, activeFilterIds } = this.props
    const props = {
      key: filter.id,
      options: filter.filter_terms,
      filterId: filter.id,
      activeFilterIds,
      setActiveFilterIds,
    }

    switch (filter.filter_type) {

      case keywords.checkbox:
        return <CheckboxGroup {...props} containerClassName="" checkboxClassName="checkbox-radio-sm checkbox-radio-blue" isFilteredSearch={true} />

      case keywords.radio:
        return <RadioButtonGroup {...props} containerClassName="" radioClassName="checkbox-radio-sm checkbox-radio-blue" />

      case keywords.slider:
        return <Slider {...props} sliderClassName="slider-blue slider-sm" />

      case keywords.multiselect:
        return filter.filter_terms.map(filterTerm =>
          <MultiselectDropdown
            key={filterTerm.id}
            options={filterTerm.children}
            title={filterTerm.name}
            parentId={filterTerm.id}
            isFilteredSearch={true}
            displayTextFilter={filter.enable_search_filter}
            activeFilterIds={activeFilterIds}
            setActiveFilterIds={setActiveFilterIds}
            additionalFilters={filterTerm.additional_filters}
          />
        )

      default:
        return null
    }
  }

  render() {
    const { filters } = this.props

    return (
      <div className="filtered-search-filters">
        { filters.map((filter, idx) =>
          <fieldset key={idx} className={filter.filter_type === keywords.slider ? 'slider-fieldset' : '' }>
            {this._renderFilterHeader(filter)}
            {this._renderFilterByType(filter)}
          </fieldset>
        ) }
      </div>
    )
  }
}

FilteredSearchFilters.propTypes = {
  filters: PropTypes.array,
  activeFilterIds: PropTypes.array,
  setActiveFilterIds: PropTypes.func
}

export default FilteredSearchFilters
